import styled from 'styled-components'

export const StyledContributorLayout = styled.div`
    height: 100%;
    display: grid;
    overflow: hidden;
`
